<template>
  <div
    class="fixed left-0 z-50 w-full overflow-y-auto transition-all duration-500 transform top-full"
    :class="enable_cookie ? '-translate-y-0' : '-translate-y-full'"
  >
    <div
      class="flex flex-wrap items-center justify-between w-full px-5 py-5 shadow-xl md:px-10 md:flex-nowrap bg-primary"
    >
      <p
        class="block w-full mb-5 text-sm text-white md:text-base md:w-auto md:mb-0"
      >
        我們使用 Cookie
        來確保您在網站上能獲得良好的體驗。如果您繼續使用本網站，我們將認定您接受並理解我們的
        <router-link class="underline" to="/terms/site_privacy"
          >隱私政策</router-link
        >
        <!-- 和
        <router-link class="underline" to="/terms/terms_of_customer"
          >使用者條款</router-link
        > -->
        。
      </p>

      <div class="flex-shrink-0 w-full text-center md:ml-5 md:w-auto">
        <button
          @click="AspectConsent"
          class="px-10 py-2 text-black transition-all duration-300 bg-white border border-white rounded-full md:hover:text-white md:hover:bg-primary md:px-5"
        >
          接受
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GTM_UpdateConsent } from "@/common/gtm_methods";
export default {
  name: "CookieConsentDialog",
  data() {
    return {
      enable_cookie: false,
    };
  },
  methods: {
    AspectConsent() {
      this.enable_cookie = true;
      GTM_UpdateConsent(true);
    },
  },
};
</script>
